// extracted by mini-css-extract-plugin
export var buttons = "_aq-0";
export var buttonsActive = "_aq-h";
export var cancelConfirm = "_aq-1";
export var closeButton = "_aq-2";
export var column = "_aq-3";
export var container = "_aq-4";
export var detailHeader = "_aq-6";
export var detailTitle = "_aq-7";
export var detailsContent = "_aq-5";
export var header = "_aq-8";
export var headerWithClose = "_aq-9";
export var icon = "_aq-a";
export var infoIcon = "_aq-c";
export var informationContainer = "_aq-b";
export var sideDrawer = "_aq-d";
export var sideDrawerOpen = "_aq-e";
export var stickyFooter = "_aq-f";
export var typeOption = "_aq-g";